import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const signals = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: 'Your data is protected'
    },
    {
      icon: 'Lock',
      title: 'Privacy First',
      description: 'Complete anonymity guaranteed'
    },
    {
      icon: 'UserCheck',
      title: 'Verified Users',
      description: 'Age-verified community'
    },
    {
      icon: 'Eye',
      title: 'Discreet Platform',
      description: 'No social media linking'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {signals?.map((signal, index) => (
        <div
          key={index}
          className="flex flex-col items-center text-center p-4 rounded-lg bg-muted hover:bg-muted/80 transition-smooth"
        >
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mb-2">
            <Icon name={signal?.icon} size={20} color="var(--color-primary)" />
          </div>
          <h4 className="text-xs font-caption font-semibold mb-1">{signal?.title}</h4>
          <p className="text-xs text-muted-foreground">{signal?.description}</p>
        </div>
      ))}
    </div>
  );
};

export default TrustSignals;